import MarketplaceItemTabs from './MarketplaceItemTabs'

export default MarketplaceItemTabs
